import { ReactNode } from 'react';
import { Link } from 'react-router-dom';
import { StarIcon } from '../ui/Icons';

interface AuthBenefit {
  label: string;
  description: string;
}

interface AuthLayoutProps {
  heading: ReactNode;
  description: string;
  benefits: AuthBenefit[];
  children: ReactNode;
}

function AuthLogo({ compact }: { compact?: boolean }) {
  return (
    <Link to="/" className="flex items-center gap-2">
      <img
        src="/images/categories/icon-7.webp"
        alt=""
        className={compact ? 'w-8 h-8 shrink-0' : 'w-10 h-10 shrink-0 -mt-1'}
      />
      <span className={`font-brand text-chocolate-dark tracking-wide ${compact ? 'text-xl' : 'text-2xl'}`}>
        Baby Chic
      </span>
    </Link>
  );
}

export function AuthLayout({ heading, description, benefits, children }: AuthLayoutProps) {
  return (
    <div className="min-h-[calc(100vh-64px)] flex -mb-16">
      {/* Painel esquerdo — apresentação da marca (oculto em mobile) */}
      <div className="hidden lg:flex flex-col justify-between w-[46%] px-12 py-14 bg-gradient-to-br from-champagne via-champagne to-champagne-dark">
        <div>
          <AuthLogo />
          <p className="text-sm text-text-medium tracking-widest uppercase font-medium ml-1 mt-2">
            Vestimos criança como criança!
          </p>
        </div>

        <div className="flex-1 flex flex-col justify-center">
          <h2 className="text-4xl font-bold text-text-dark leading-snug mb-4">{heading}</h2>
          <p className="text-text-medium text-base leading-relaxed max-w-xs">{description}</p>
        </div>

        <div className="grid grid-cols-1 gap-4">
          {benefits.map((b) => (
            <div key={b.label} className="flex items-start gap-3">
              <StarIcon className="text-chocolate mt-0.5 w-3.5 h-3.5 shrink-0" />
              <div>
                <p className="text-sm font-semibold text-text-dark">{b.label}</p>
                <p className="text-xs text-text-light">{b.description}</p>
              </div>
            </div>
          ))}
        </div>

        <p className="text-xs text-text-light mt-8">
          © {new Date().getFullYear()} BabyChic — Todos os direitos reservados
        </p>
      </div>

      {/* Painel direito — formulário */}
      <div className="flex-1 flex items-center justify-center px-6 py-12 bg-champagne-light">
        <div className="w-full max-w-md">
          <div className="flex lg:hidden justify-center mb-8">
            <AuthLogo compact />
          </div>

          {children}
        </div>
      </div>
    </div>
  );
}
